var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MatcMainCntr",attrs:{"id":"app"}},[_c('router-view'),_c('div',{ref:"message",staticClass:"vommondMessage"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }